import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { MainLayout } from 'src/layout';
import {
	CompanyAccount,
	CreateCampaign,
	Integrations,
	ManageUsers,
	Products,
	Campaigns,
	Groups,
	Apps,
	App,
	SubscriptionPage,
	AiVoiceAgent,
} from 'src/pages';
import NotAllowedMessage from 'src/components/common/NotAllowedMessage';
import Design from 'src/pages/design/Design';

// TODO: Remove redirect import and use import from src/pages
import RefreshPage from 'src/pages/misc/RefreshPage';
import authService from 'src/services/auth';
import { IUser } from 'src/lib/schemas';
import Home from 'src/pages/home/Home';
import Templates from 'src/pages/account/Templates';
import TemplatesForm from 'src/components/account/Templates/parts/TemplatesForm';
import FacebookCallback from 'src/pages/integrations/FacebookCallback';
import Tags from 'src/pages/commerce/Tags';
import CreateEditCampaign from 'src/pages/campaigns/CreateEditCampaign';
import SuccessPage from 'src/pages/account/subscription/redirect/Success';
import CancelPage from 'src/pages/account/subscription/redirect/Cancel';
import CampaignTopupSuccess from 'src/pages/account/subscription/redirect/CampaignTopupSuccess';
import CampaignTopupCancel from 'src/pages/account/subscription/redirect/CampaignTopupCancel';
import { shouldShowPublicWebsite } from 'src/lib/utils/subdomain';

export const defaultTemplate = {
	elements: [
		{
			z_index: 1,
			track: 1,
			id: '17cad4e8-216b-4ffe-a045-ecab844ed733',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: 'color',
			x: '0%',
			y: '0%',
			type: 'shape',
			fill_color: 'rgba(255,255,255,1)',
			path: 'M -25.0 -56.0 C -25.0 -56.0 1055.0 -56.0 1055.0 -56.0 1055.0 -56.0 1055.0 1024.0 1055.0 1024.0 1055.0 1024.0 -25.0 1024.0 -25.0 1024.0 -25.0 1024.0 -25.0 -56.0 -25.0 -56.0 Z',
		},
		{
			z_index: 2,
			track: 2,
			id: '0f6404b6-3adf-46a4-a81a-1e751230e13b',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: 'background',
			x: '0%',
			y: '0%',
			type: 'shape',
			fill_color: 'rgba(255,255,255,1)',
			path: 'M -25.0 -56.0 C -25.0 -56.0 1055.0 -56.0 1055.0 -56.0 1055.0 -56.0 1055.0 1024.0 1055.0 1024.0 1055.0 1024.0 -25.0 1024.0 -25.0 1024.0 -25.0 1024.0 -25.0 -56.0 -25.0 -56.0 Z',
		},
		{
			z_index: 3,
			track: 3,
			id: '926adbab-0090-43d9-ab25-c573bc1d5107',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: '$Product',
			x: '-3.71 %',
			y: '-4.49 %',
			width: '106.45 %',
			height: '107.42 %',
			type: 'image',
			source:
				'https://static.stage.fusionos.ai/users/65a547282b2c77bc80cc8f12/images/bee530e2-7147-47ab-a7cc-282d8d77535b.png',
			visible: true,
		},
		{
			z_index: 4,
			track: 4,
			id: '04621905-5601-4007-8965-b6e557b36c92',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: 'overlay',
			x: '0%',
			y: '0%',
			type: 'shape',
			path: 'M 1068.9962158203125 1024.0061645507812 C 1068.9962158203125 1024.0061645507812 -38.9962158203125 1024.0061645507812 -38.9962158203125 1024.0061645507812 -38.9962158203125 1024.0061645507812 -38.9962158203125 -67.00616455078125 -38.9962158203125 -67.00616455078125 -38.9962158203125 -67.00616455078125 1068.9962158203125 -67.00616455078125 1068.9962158203125 -67.00616455078125 1068.9962158203125 -67.00616455078125 1068.9962158203125 1024.0061645507812 1068.9962158203125 1024.0061645507812 Z',
		},
		{
			z_index: 5,
			track: 5,
			id: '05328be4-c5e0-45f4-968f-7ec63ecd15bc',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: 'overlay copy',
			x: '0%',
			y: '0%',
			type: 'shape',
			path: 'M 1068.9962158203125 1024.0017700195312 C 1068.9962158203125 1024.0017700195312 -38.9962158203125 1024.0017700195312 -38.9962158203125 1024.0017700195312 -38.9962158203125 1024.0017700195312 -38.9962158203125 700.9981689453125 -38.9962158203125 700.9981689453125 -38.9962158203125 700.9981689453125 1068.9962158203125 700.9981689453125 1068.9962158203125 700.9981689453125 1068.9962158203125 700.9981689453125 1068.9962158203125 1024.0017700195312 1068.9962158203125 1024.0017700195312 Z',
		},
		{
			z_index: 6,
			track: 6,
			id: 'c2bf9abb-faa9-4203-9f1a-9bdc290e0af7',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: 'call',
			x: '0%',
			y: '0%',
			width: '100%',
			height: '100%',
			type: 'composition',
			elements: [
				{
					parentId: 12,
					z_index: 7,
					track: 7,
					id: 'fd1270cc-1f9d-44bd-af07-537ca29706cd',
					x_anchor: '0%',
					y_anchor: '0%',
					opacity: '100%',
					name: '$phone description',
					x: '77.34 %',
					y: '87.50 %',
					width: '13.28 %',
					height: '3.32 %',
					type: 'text',
					text: 'Contact us',
					text_clip: true,
					font_family: 'Montserrat',
					font_weight: 400,
					font_style: 'SemiBold',
					fill_color: 'rgba(255,255,255,1)',
					text_transform: 'uppercase',
					y_alignment: '50%',
					x_alignment: '100%',
				},
				{
					parentId: 12,
					z_index: 8,
					track: 8,
					id: '8e770398-0e53-47fa-9f3e-eb4d35ec1402',
					x_anchor: '0%',
					y_anchor: '0%',
					opacity: '100%',
					name: '$account.phone',
					x: '72.66 %',
					y: '89.75 %',
					width: '17.77 %',
					height: '4.39 %',
					type: 'text',
					text: '(Your phone)',
					text_clip: true,
					font_family: 'Montserrat',
					font_weight: 800,
					font_style: 'Bold',
					fill_color: 'rgba(255,255,255,1)',
					y_alignment: '50%',
					x_alignment: '100%',
				},
				{
					parentId: 12,
					z_index: 9,
					track: 9,
					id: '78a7700b-387a-4223-bdcd-dda97b65412d',
					x_anchor: '0%',
					y_anchor: '0%',
					opacity: '100%',
					name: 'Shape 2',
					x: '0%',
					y: '0%',
					type: 'shape',
					fill_color: 'rgba(255,255,255,1)',
					path: 'M 991.7454833984375 915.4639282226562 C 991.4470825195312 914.0014038085938 990.790283203125 912.697998046875 989.7353515625 911.6235961914062 988.35205078125 910.2008666992188 986.9985961914062 908.6985473632812 985.505859375 907.3953247070312 983.2169799804688 905.4055786132812 980.739013671875 905.41552734375 978.5396118164062 907.48486328125 976.5293579101562 909.365234375 974.5887451171875 911.3252563476562 972.6880493164062 913.3447265625 972.3795166015625 913.6630249023438 972.0808715820312 913.991455078125 971.7526245117188 914.3297119140625 970.7275390625 915.4240112304688 970.3592529296875 916.886474609375 970.6280517578125 918.2694702148438 970.77734375 919.0852661132812 971.1355590820312 919.8711547851562 971.7327270507812 920.5379028320312 972.8970336914062 921.8609008789062 974.1708374023438 923.0946044921875 975.4446411132812 924.3480834960938 975.6735229492188 924.5770263671875 975.7333374023438 924.7461547851562 975.5838623046875 925.074462890625 974.4993896484375 927.2333374023438 973.0562744140625 929.1136474609375 971.4739379882812 930.9044799804688 971.1953125 931.212890625 970.896728515625 931.5213012695312 970.617919921875 931.8296508789062 970.3692016601562 932.0883178710938 970.1304321289062 932.3469848632812 969.8816528320312 932.595703125 968.1200561523438 934.406494140625 966.1796264648438 936.0082397460938 964.050048828125 937.3811645507812 963.3433227539062 937.81884765625 962.60693359375 938.1770629882812 961.8306884765625 938.6049194335938 961.004638671875 937.7692260742188 960.1886596679688 936.943603515625 959.3626708984375 936.1177368164062 958.8154296875 935.5704345703125 958.2680053710938 935.0233154296875 957.6608276367188 934.5358276367188 955.8895263671875 933.0632934570312 953.222412109375 933.0335693359375 951.5604858398438 934.6154174804688 949.1422119140625 936.923583984375 946.7737426757812 939.291259765625 944.4747924804688 941.7188720703125 942.7830200195312 943.51953125 942.76318359375 946.2554931640625 944.4052124023438 948.1060791015625 944.5046997070312 948.225341796875 944.604248046875 948.3348999023438 944.713623046875 948.4542846679688 946.1369018554688 950.046142578125 947.6296997070312 951.5881958007812 949.2117919921875 953.0407104492188 950.8441162109375 954.503173828125 952.8443603515625 954.9806518554688 954.9739379882812 954.8812255859375 955.1629638671875 954.8812255859375 955.3521118164062 954.8712768554688 955.5510864257812 954.8515014648438 959.9597778320312 954.4732666015625 963.86083984375 952.7023315429688 967.6425170898438 950.6032104492188 971.4839477539062 948.4740600585938 974.967041015625 945.8975219726562 978.1017456054688 942.8629760742188 978.7586059570312 942.2262573242188 979.4054565429688 941.5697021484375 980.0422973632812 940.8831787109375 981.6644897460938 939.152099609375 983.1671752929688 937.3612670898438 984.5404663085938 935.48095703125 984.9386596679688 934.9637451171875 985.3068237304688 934.4164428710938 985.6751708984375 933.8692626953125 986.5407104492188 932.605712890625 987.3270263671875 931.3123168945312 988.0335083007812 929.9593505859375 988.5510864257812 929.0540161132812 989.0187377929688 928.098876953125 989.4467163085938 927.1238403320312 989.4467163085938 927.1238403320312 989.4467163085938 927.0741577148438 989.4467163085938 927.0741577148438 989.4467163085938 927.0741577148438 989.4567260742188 927.0642700195312 989.4567260742188 927.0642700195312 989.8050537109375 926.2882080078125 990.1334228515625 925.5619506835938 990.4319458007812 924.7562255859375 990.611083984375 924.3084106445312 990.770263671875 923.8408203125 990.9097290039062 923.3930053710938 991.4470825195312 921.7515258789062 991.8451538085938 920.0701904296875 991.9148559570312 918.3191528320312 991.9148559570312 918.209716796875 991.95458984375 918.0903930664062 991.984375 917.98095703125 991.984375 917.98095703125 991.984375 917.2745971679688 991.984375 917.2745971679688 991.9049682617188 916.6676025390625 991.8650512695312 916.0609130859375 991.7454833984375 915.4639282226562 Z M 988.8297729492188 919.4633178710938 C 988.7999267578125 919.7319946289062 988.730224609375 919.9906005859375 988.670654296875 920.25927734375 988.6506958007812 920.3785400390625 988.6207275390625 920.4780883789062 988.5809936523438 920.5974731445312 988.5809936523438 920.5974731445312 988.5809936523438 920.607421875 988.5809936523438 920.607421875 987.894287109375 923.5324096679688 986.7399291992188 926.2584838867188 985.2669067382812 928.844970703125 985.0181274414062 929.3126831054688 984.7395629882812 929.7802734375 984.4708862304688 930.238037109375 983.1075439453125 932.4366455078125 981.6345825195312 934.5059814453125 980.0324096679688 936.43603515625 979.13671875 937.5105590820312 978.2213134765625 938.5551147460938 977.236083984375 939.5499877929688 973.4144897460938 943.4798583984375 968.9760131835938 946.7429809570312 963.8508911132812 949.2600708007812 961.1538696289062 950.5833129882812 958.37744140625 951.6578369140625 955.34228515625 951.9264526367188 954.2275390625 952.0159912109375 953.222412109375 951.8966064453125 952.2770385742188 951.49853515625 952.2770385742188 951.49853515625 952.26708984375 951.49853515625 952.26708984375 951.49853515625 951.64013671875 951.2299194335938 951.0629272460938 950.842041015625 950.5354614257812 950.2947998046875 950.5354614257812 950.2947998046875 950.4259643554688 950.1953125 950.4259643554688 950.1953125 949.3313598632812 949.041259765625 948.2066650390625 947.9170532226562 947.0921630859375 946.7828369140625 945.8582763671875 945.4993896484375 945.8582763671875 944.4349365234375 947.0921630859375 943.1715087890625 947.9281005859375 942.3157958984375 948.783935546875 941.4701538085938 949.6398315429688 940.6245727539062 950.8140869140625 939.4505615234375 952.0083618164062 938.2567138671875 953.1925048828125 937.082763671875 954.108154296875 936.1873168945312 955.1232299804688 936.1774291992188 956.0787353515625 937.0131225585938 956.2577514648438 937.1622924804688 956.4068603515625 937.3114624023438 956.5563354492188 937.470703125 957.7206420898438 938.6248168945312 958.875 939.7887573242188 960.0394287109375 940.952880859375 960.8653564453125 941.748779296875 961.7709350585938 941.94775390625 962.726318359375 941.4701538085938 963.7314453125 940.9727172851562 964.7166748046875 940.4454956054688 965.6521606445312 939.8485107421875 967.9609375 938.3860473632812 970.0309448242188 936.6549072265625 971.9515991210938 934.7448120117188 972.4791870117188 934.1975708007812 972.9966430664062 933.6404418945312 973.5140380859375 933.0733032226562 973.6732788085938 932.8942260742188 973.8224487304688 932.7252197265625 973.9618530273438 932.555908203125 975.6735229492188 930.5960083007812 977.2261352539062 928.5366821289062 978.3206176757812 926.1688232421875 978.6990356445312 925.3232421875 978.89794921875 924.7362060546875 978.8381958007812 924.2288208007812 978.7785034179688 923.5820922851562 978.3804321289062 923.0648193359375 977.5643310546875 922.2789306640625 977.007080078125 921.7217407226562 976.419921875 921.1646118164062 975.8526611328125 920.607421875 975.8426513671875 920.607421875 975.8426513671875 920.5974731445312 975.8326416015625 920.5875244140625 975.2555541992188 920.0204467773438 974.6882934570312 919.4334716796875 974.1310424804688 918.8464965820312 973.4642333984375 918.1300659179688 973.3347778320312 917.40380859375 973.7230834960938 916.6676025390625 973.8125610351562 916.4588012695312 973.9419555664062 916.2697143554688 974.0911254882812 916.0707397460938 974.1509399414062 916.02099609375 974.1708374023438 915.981201171875 974.220703125 915.931396484375 974.220703125 915.931396484375 974.220703125 915.92138671875 974.220703125 915.92138671875 974.2803344726562 915.8518676757812 974.3399047851562 915.792236328125 974.3897705078125 915.7324829101562 976.4099731445312 913.7228393554688 978.4102783203125 911.713134765625 980.4205322265625 909.7133178710938 980.6394653320312 909.5045166015625 980.8882446289062 909.3055419921875 981.156982421875 909.166259765625 982.0227661132812 908.728515625 982.8786010742188 908.9274291992188 983.7543334960938 909.7930297851562 984.8888549804688 910.8973388671875 985.9935302734375 912.0613403320312 987.1279907226562 913.1556396484375 988.4415893554688 914.389404296875 989.05859375 915.9014892578125 988.9988403320312 917.7023315429688 988.939208984375 918.2794189453125 988.8894653320312 918.8663940429688 988.8297729492188 919.4633178710938 Z M 962.8617553710938 902.9703979492188 C 961.6898803710938 903.2744140625 960.505126953125 903.5364379882812 959.3485717773438 903.89013671875 955.5806274414062 905.0425415039062 952.22607421875 906.9509887695312 949.2715454101562 909.5508422851562 946.1321411132812 912.3135375976562 943.7006225585938 915.603271484375 942.0236206054688 919.4400634765625 941.1209106445312 921.5053100585938 940.4864501953125 923.6527709960938 940.1098022460938 925.8739624023438 939.9747314453125 926.670654296875 940.4229125976562 927.3352661132812 941.1769409179688 927.528076171875 941.9397583007812 927.72314453125 942.7116088867188 927.3309326171875 942.933349609375 926.5545654296875 943.2432861328125 925.4693603515625 943.4442749023438 924.352294921875 943.7697143554688 923.2723388671875 945.2349243164062 918.4105224609375 947.989990234375 914.403564453125 951.906494140625 911.1912231445312 955.1822509765625 908.5045166015625 958.9103393554688 906.77685546875 963.0775146484375 905.9927978515625 964.2155151367188 905.7786865234375 964.72216796875 905.2523193359375 964.6915283203125 904.3858032226562 964.6651000976562 903.641357421875 964.1896362304688 903.2490234375 963.5718994140625 902.9703979492188 963.3351440429688 902.9703979492188 963.0984497070312 902.9703979492188 962.8617553710938 902.9703979492188 Z M 965.1109008789062 913.8606567382812 C 965.1021118164062 912.9173583984375 964.2811279296875 912.2310791015625 963.31591796875 912.4271240234375 957.2215576171875 913.6644287109375 952.9197387695312 917.13427734375 950.4940795898438 922.8618774414062 950.0507202148438 923.908935546875 949.8118896484375 925.0471801757812 949.5297241210938 926.1563720703125 949.3104248046875 927.0186767578125 949.8009033203125 927.7963256835938 950.6109619140625 927.9949340820312 951.3796997070312 928.18359375 952.1407470703125 927.7086181640625 952.3939208984375 926.8778686523438 952.7326049804688 925.7671508789062 952.9488525390625 924.6010131835938 953.4259643554688 923.553466796875 955.4619750976562 919.0825805664062 958.927734375 916.3541259765625 963.7451171875 915.351806640625 964.6461181640625 915.1644287109375 965.1181640625 914.6453857421875 965.1109008789062 913.8606567382812 Z',
				},
			],
		},
		{
			z_index: 10,
			track: 10,
			id: 'f3059b45-63a9-4c89-b650-2de7d518b60e',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: '$direction.promotion[0]?',
			x: '0%',
			y: '0%',
			width: '100%',
			height: '100%',
			type: 'composition',
			elements: [
				{
					parentId: 16,
					z_index: 11,
					track: 11,
					id: '10d174c6-9d7f-4af5-903d-ab2f2cb1b1aa',
					x_anchor: '0%',
					y_anchor: '0%',
					opacity: '100%',
					name: '$direction.promotion[0].code',
					x: '3.22 %',
					y: '89.84 %',
					width: '29.69 %',
					height: '6.84 %',
					type: 'text',
					text: '$campaign.promotion[0].code',
					text_clip: true,
					font_family: 'Montserrat',
					font_weight: 800,
					font_style: 'Bold',
					fill_color: 'rgba(255,255,255,1)',
					y_alignment: '50%',
				},
				{
					parentId: 16,
					z_index: 12,
					track: 12,
					id: 'cc5dd44b-58c6-4a96-98c0-2cd56e57eecf',
					x_anchor: '0%',
					y_anchor: '0%',
					opacity: '100%',
					name: '$direction.promotion[0].description',
					x: '3.22 %',
					y: '86.82 %',
					width: '26.46 %',
					height: '4.39 %',
					type: 'text',
					text: '$campaign.promotion[0].description',
					text_clip: true,
					font_family: 'Montserrat',
					font_weight: 400,
					font_style: 'SemiBold',
					fill_color: 'rgba(255,255,255,1)',
					y_alignment: '50%',
				},
			],
			visible: false,
		},
		{
			z_index: 13,
			track: 13,
			id: 'df05235c-6375-4dc7-8ae6-c3f45e5c2427',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: 'Button',
			x: '0%',
			y: '0%',
			width: '100%',
			height: '100%',
			type: 'composition',
			elements: [
				{
					parentId: 22,
					z_index: 14,
					track: 14,
					id: 'bfd7846f-c025-411d-9adf-4c4ac89c1ecc',
					x_anchor: '0%',
					y_anchor: '0%',
					opacity: '100%',
					name: 'Rectangle 3',
					x: '0%',
					y: '0%',
					type: 'shape',
					fill_color: 'rgba(255,255,255,1)',
					path: 'M 392.0 922.0 C 392.0 922.0 639.0 922.0 639.0 922.0 641.2091064453125 922.0 643.0 923.7908325195312 643.0 926.0 643.0 926.0 643.0 968.0 643.0 968.0 643.0 970.2091064453125 641.2091064453125 972.0 639.0 972.0 639.0 972.0 392.0 972.0 392.0 972.0 389.79083251953125 972.0 388.0 970.2091064453125 388.0 968.0 388.0 968.0 388.0 926.0 388.0 926.0 388.0 923.7908325195312 389.79083251953125 922.0 392.0 922.0 Z',
				},
				{
					parentId: 22,
					z_index: 15,
					track: 15,
					id: 'd77b7439-0deb-4616-9402-800bc7aa6746',
					x_anchor: '0%',
					y_anchor: '0%',
					opacity: '100%',
					name: '$direction.callToAction',
					x: '40.43 %',
					y: '90.33 %',
					width: '18.75 %',
					height: '4.20 %',
					type: 'text',
					text: 'Contact Us',
					text_clip: true,
					font_family: 'Montserrat',
					font_weight: 800,
					font_style: 'Bold',
					fill_color: 'rgba(25,25,25,1)',
					y_alignment: '50%',
					x_alignment: '50%',
				},
			],
		},
		{
			z_index: 16,
			track: 16,
			id: '80ed6995-9c73-44f6-ba1d-c692354e752a',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: '$direction.punchline',
			x: '2.93 %',
			y: '29.10 %',
			width: '93.26 %',
			height: '10.06 %',
			type: 'text',
			text: "Your baby's best warmth",
			text_clip: true,
			font_family: 'Bebas Neue',
			font_weight: 400,
			font_style: 'Regular',
			fill_color: 'rgba(25,25,25,1)',
			y_alignment: '50%',
			x_alignment: '50%',
			visible: true,
		},
		{
			z_index: 17,
			track: 17,
			id: '013fab52-092f-4734-9d7f-461cb1587202',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: '$title',
			x: '4.49 %',
			y: '17.48 %',
			width: '90.43 %',
			height: '10.55 %',
			type: 'text',
			text: 'Lorem ipsum dolor sit amet, consectetuer adip',
			text_clip: true,
			font_family: 'Anton',
			font_weight: 400,
			font_style: 'Regular',
			fill_color: 'rgba(25,25,25,1)',
			text_transform: 'uppercase',
			y_alignment: '50%',
			x_alignment: '50%',
		},
		{
			z_index: 18,
			track: 18,
			id: '740ff27a-a155-402b-9f29-5f27850fae66',
			x_anchor: '0%',
			y_anchor: '0%',
			opacity: '100%',
			name: '$account.logo',
			x: '35.55 %',
			y: '1.37 %',
			width: '29.00 %',
			height: '14.06 %',
			type: 'image',
			source:
				'https://storage.googleapis.com/fusion-images/psd/aa505d2d-cfb8-46fb-a790-e53af10122dc.png',
			text: 'https://static.stage.fusionos.ai/users/fusion_demo/catalogs/a5eecadf-0ceb-44be-9ae9-34791032180d.png',
			visible: true,
		},
	],
	templateId: 'car-wash-2',
	width: 1024,
	height: 1024,
	fonts: [
		{
			family: 'PollerOne',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/PollarOne-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Poppins',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Poppins-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Montserrat',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Montserrat-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'BebasNeue',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BebasNeue-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'ACaslonPro',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Adobe-Caslon-Pro-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Quicksand',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Quicksand-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'PlayfairDisplay',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/PlayfairDisplay-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'HankenGrotesk',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/HankenGrotesk-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Macho',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Macho-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Gotham',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Gotham-Medium.otf',
			bold: 700,
			regular: 350,
		},
		{
			family: 'OpenSans',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/OpenSans-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Nunito',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Nunito-Medium.ttf',
			bold: 700,
			regular: 500,
		},
		{
			family: 'ButterChicken',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Butter-Chicken-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Chillax',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Chillax-Regular.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'PuisiAdinda',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Puisi-Adinda.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'ClashGrotesk',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/ClashGrotesk-Regular.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Cormorant',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Cormorant-Regular.ttf',
			bold: 600,
			regular: 400,
		},
		{
			family: 'Roboto',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Roboto-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Pangram',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Pangram-Regular.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'MrDeHaviland',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/MrDeHaviland-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Raleway',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Raleway-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'GoogleSans',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/GoogleSans-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Avenir',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Avenir-Regular.ttf',
			bold: 850,
			regular: 400,
		},
		{
			family: 'LunchBoxSlab',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/LunchBoxSlab.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Inter',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Inter-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Consolas',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Consola-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'SourceSansPro',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/SourceSansPro-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'FranklinGothic',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Franklin-Gothic-Demi-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Franklin',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Franklin-Gothic-Medium-Cursive.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Impact',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Impact.TTF',
			bold: 400,
			regular: 400,
		},
		{
			family: 'NunitoSans7pt',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/NunitoSans7pt-Medium.TTF',
			bold: 700,
			regular: 500,
		},
		{
			family: 'CabinSketch',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/CabinSketch-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'BarlowSemiCondensed',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BarlowSemiCondensed-Bold.ttf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'HeadingProTrial',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Heading-Pro-Trial-Bold.ttf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'HelveticaNeue',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/HelveticaNeue-Medium.otf',
			bold: 500,
			regular: 500,
		},
		{
			family: 'Abigral',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Abigral-w1OE9.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'QuattrocentoSans',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/QuattrocentoSans-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Syne',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Syne-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'NeueHaasGroteskTextPro',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/NeueHaasGroteskTextPro-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Candara',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Candara-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Gilroy',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Gilroy-Bold.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'BebasNeueBold',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BebasNeue-Bold.ttf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'MyriadPro',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/MyriadPro-Regular.OTF',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Georgia',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Georgia.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'CocogooseProTrial',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Cocogoose-Pro-Semilight-trial.ttf',
			bold: 700,
			regular: 350,
		},
		{
			family: 'DelaGothicOne',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/DelaGothicOne-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Kanit',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Kanit-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Lato',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Lato-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Antonio',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Antonio-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Anton',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Anton-Regular.TTF',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Bokis',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Bokis-Oblique.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'GimbalExtended',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/GimbalExtended-Regular.otf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'SpaceGrotesk',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/SpaceGrotesk-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'InterTight',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/InterTight-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'AlbertSans',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/AlbertSans-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Arvo',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Arvo-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'OpenSans_SemiCondensed',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/OpenSans_SemiCondensed-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Australian',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/AustralianSignature.otf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'BrittanySignatureRegular',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BrittanySignature.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'AbrilFatface',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/AbrilFatface-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'HiraginoKakuGothicProW3',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/HiraginoKakuGothicProW3.otf',
			bold: 300,
			regular: 300,
		},
		{
			family: 'HiraginoKakuGothicProW6',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/HiraginoKakuGothicProW6.otf',
			bold: 600,
			regular: 600,
		},
		{
			family: 'HiraginoKakuGothicProW8',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/HiraginoKakuGothicProW8.otf',
			bold: 800,
			regular: 800,
		},
		{
			family: 'Unbounded',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Unbounded-Bold.ttf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'BalooBhai2',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BalooBhai2-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Knewave',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Knewave-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'RobotoSlab',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/RobotoSlab-Bold.ttf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'HennyPenny',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/HennyPenny-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Lobster',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Lobster-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'FeastofFleshBB',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/feast-of-flesh-bb-regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Yellowtail',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Yellowtail-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Crimson',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Crimson-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Atma',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Atma-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'YesevaOne',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/YesevaOne-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Bebas',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Bebas-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'GreatVibes',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/GreatVibes-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'moon_get',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/moon_get-Heavy.ttf',
			bold: 800,
			regular: 800,
		},
		{
			family: 'ProhibitionTest',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/ProhibitionTest-Regular.otf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Oraghon',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Oraghon-Script.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Spooky',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Spooky-Monster.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Shlop',
			source: 'https://storage.googleapis.com/fusion-templates/fonts/Shlop.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'August',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/August-Bold.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Skranji',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Skranji-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'AmericanTypewriter',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/American-Typewriter-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Sansita',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Sansita-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'NotoSans',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/NotoSans-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'FONTSPRINGDEMO',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/TheSeasons-Bold.otf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'SuperComic',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/SuperComic.otf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'NewTaiLue',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/NewTaiLue-Bold.ttf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'NewTailLue',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/NewTailLue.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'RetroTeam',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/RetroTeam.otf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Square721BT',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Square721BT-RomanCondensed.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'BerkshireSwash',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BerkshireSwash-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'ClarendonBT',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/ClarendonBT.TTF',
			bold: 700,
			regular: 400,
		},
		{
			family: 'PermanentMarker',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/PermanentMarker-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'DancingScript',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/DancingScript-Regular.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Rodetta',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Rodetta.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'BigCaslonFB',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BigCaslonCC-Italic.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'FuturaCyrillicBold',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/FuturaCyrillic-Bold.ttf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'FuturaCyrillicBook',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/FuturaCyrillic-Book.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'FuturaCyrillicDemi',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/FuturaCyrillic-Demi.ttf',
			bold: 500,
			regular: 500,
		},
		{
			family: 'FuturaCyrillicExtraBold',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/FuturaCyrillic-ExtraBold.ttf',
			bold: 800,
			regular: 800,
		},
		{
			family: 'FuturaCyrillicHeavy',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/FuturaCyrillic-Heavy.ttf',
			bold: 600,
			regular: 600,
		},
		{
			family: 'FuturaCyrillicLight',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/FuturaCyrillic-Light.ttf',
			bold: 300,
			regular: 300,
		},
		{
			family: 'FuturaCyrillicMedium',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/FuturaCyrillic-Medium.ttf',
			bold: 450,
			regular: 450,
		},
		{
			family: 'GillSansMT',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/GillSans-Condensed.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'BodoniMT',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BodoniMT.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Epilogue',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Epilogue-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Oi',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Oi-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'PlaywriteHR',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/PlaywriteHR-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Didot',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Didot-Italic.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'DidotTitle',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/DidotTitle.otf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Rubik',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Rubik-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'BRHendrix',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BRHendrix-Regular.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Aeonik',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Aeonik-Regular.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Manrope',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Manrope-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'BricolageGrotesque',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BricolageGrotesque-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'EuclidCircular',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/EuclidCircular-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'ClashDisplay',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/ClashDisplay-Regular.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'AvenirNextLTPro',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/AvenirNextLTPro-CondItalic.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'RocGrotesk',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/RocGrotesk-Regular.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'CheeseMatcha',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/CheeseMatcha.OTF',
			bold: 400,
			regular: 400,
		},
		{
			family: 'JosefinSansRoman',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/JosefinSans-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Oswald',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Oswald-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'ComicSansMS',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/ComicSansMS-Cursiva.TTF',
			bold: 700,
			regular: 400,
		},
		{
			family: 'AgencyFB',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/AgencyFB.TTF',
			bold: 700,
			regular: 400,
		},
		{
			family: 'FreestyleScript',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/FreestyleScript.TTF',
			bold: 400,
			regular: 400,
		},
		{
			family: 'LucidaFax',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/LucidaFax-Cursive.TTF',
			bold: 600,
			regular: 400,
		},
		{
			family: 'Corinthia',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Corinthia-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'CalistoMT',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/CalistoMT-Cursive.TTF',
			bold: 700,
			regular: 400,
		},
		{
			family: 'HighTowerText',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/HighTowerText-Cursive.TTF',
			bold: 700,
			regular: 400,
		},
		{
			family: 'AmpersandTypeface',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/AmpersandTypeface.otf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'CouturierPoster',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/CouturierPoster-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'BigNoodleTitling',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BigNoodleTitling-Oblique.TTF',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Comfortaa',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Comfortaa-Regular.TTF',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Cinzel',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Cinzel-Regular.OTF',
			bold: 700,
			regular: 400,
		},
		{
			family: 'BuiltTitling',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BuiltTitling-BoldItalic.otf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'BuiltTitlingEl',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BuiltTitlingEl-Italic.otf',
			bold: 250,
			regular: 250,
		},
		{
			family: 'BuiltTitlingLt',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BuiltTitlingLt-Italic.otf',
			bold: 300,
			regular: 300,
		},
		{
			family: 'BuiltTitlingRg',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BuiltTitlingRg-Italic.otf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'BuiltTitlingSb',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BuiltTitlingSb-Italic.otf',
			bold: 600,
			regular: 600,
		},
		{
			family: 'PTSerif',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/PTSerif-Italic.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Erstoria',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Erstoria-Regular.otf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'PoiretOne',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/PoiretOne-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Biogem',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Biogem-Bold.ttf',
			bold: 700,
			regular: 700,
		},
		{
			family: 'CormorantGaramond',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/CormorantGaramond-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'CenturyGothic',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/CenturyGothic.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Marcellus',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Marcellus-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Arima',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Arima-Regular.ttf',
			bold: 600,
			regular: 400,
		},
		{
			family: 'Outfit',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Outfit-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'TenorSans',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/TenorSans-Regular.ttf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'Sernest',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Sernest-Regular.otf',
			bold: 400,
			regular: 400,
		},
		{
			family: 'BDSupper',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/BDSupper-Regular.ttf',
			bold: 700,
			regular: 400,
		},
		{
			family: 'Rosterine',
			source:
				'https://storage.googleapis.com/fusion-templates/fonts/Rosterine.otf',
			bold: 400,
			regular: 400,
		},
	],
};

const getRoutesProtected = () => {
	const isAuth = authService.isAuthenticated();
	const pathname = useLocation().pathname;
	
	// Don't redirect if already on login page to prevent infinite loops
	if (pathname === '/login') {
		return <Outlet />;
	}
	
	// Don't redirect if this is a public website subdomain (*.website.fusionads.ai)
	// Public websites should be handled separately and not require authentication
	if (shouldShowPublicWebsite()) {
		// Let the public website routes handle this instead of redirecting to login
		return <Outlet />;
	}
	
	if (isAuth) {
		return <Outlet />;
	} else {
		return <Navigate to={`/login?redirect_url=${pathname}`} />;
	}
};

const isAdministrator = (user: IUser | null) =>
	user?.role === 'verifiedAccountAdmin' || user?.role === 'accountAdmin';

interface InstagramProtectedRouteProps {
	element: JSX.Element;
}

const InstagramProtectedRoute = ({ element }: InstagramProtectedRouteProps) => {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const showInstagramRoute = searchParams.get('instagram') === 'true';

	return showInstagramRoute ? element : <Navigate to="/home" />;
};

// TODO: Remove this to a helper function when verified roles reseticions are back
// const isPendingVerification = (user: IUser | null) => !user?.isEmailVerified;

const getProtectedRoutes = (user: IUser | null) => ({
	element: getRoutesProtected(),
	children: [
		{
			element: (
				// isPendingVerification(user) ?
				// 	<PendingVerification />
				// ) : (
				<MainLayout />
			),
			// ),
			children: [
				{
					path: '/home',
					element: <Home />,
				},
				{
					path: '/integrations',
					element: <Integrations title="Integrations" />,
				},
				{
					path: '/v1/integrations/facebook/callback',
					element: <FacebookCallback />,
				},
				{
					path: 'tasks',
					children: [
						{ path: '', element: <Apps /> },
						{ path: ':appId', element: <App /> },
						{ path: ':appId/:paramActionId', element: <App /> },
					],
				},
				{
					path: 'account',
					element: <Outlet />,
					children: [
						{
							path: 'company',
							element: isAdministrator(user) ? (
								<CompanyAccount />
							) : (
								<NotAllowedMessage />
							),
						},
						{
							path: 'users',
							element: isAdministrator(user) ? (
								<ManageUsers />
							) : (
								<NotAllowedMessage />
							),
						},
						{
							path: 'subscription',
							element: isAdministrator(user) ? (
								<SubscriptionPage />
							) : (
								<NotAllowedMessage />
							),
						},
						{
							path: 'templates',
							children: [
								{ path: '', element: <Templates /> },
								{ path: 'edit/:id', element: <TemplatesForm /> },
								{ path: 'new', element: <TemplatesForm /> },
							],
						},
					],
				},
				{
					path: 'commerce',
					element: <Outlet />,
					children: [
						{ path: 'catalog', element: <Products /> },
						{ path: 'tags', element: <Tags /> },
					],
				},
				{
					path: 'ai-voice-agent',
					element: isAdministrator(user) ? (
						<AiVoiceAgent />
					) : (
						<NotAllowedMessage />
					),
				},
				{
					path: 'projects',
					element: <Outlet />,
					children: [
						{
							path: 'campaigns',
							children: [
								{ path: '', element: <Campaigns /> },
								{ path: 'deprecated/:campaignId', element: <CreateCampaign /> },
								{
									path: ':campaignId',
									element: <CreateEditCampaign />,
								},
								{
									path: ':campaignId/editing',
									element: <CreateEditCampaign />,
								},
							],
						},
						{ path: 'groups', element: <Groups /> },
					],
				},
				{ path: 'refresh-page', element: <RefreshPage /> },
			],
		},
		{
			path: 'billing',
			children: [
				{
					path: 'success',
					element: <SuccessPage />,
				},
				{ path: 'cancel', element: <CancelPage /> },
			],
		},
		{
			path: 'campaign-topup',
			children: [
				{
					path: 'success',
					element: <CampaignTopupSuccess />,
				},
				{ path: 'cancel', element: <CampaignTopupCancel /> },
			],
		},
	],
});

export default getProtectedRoutes;
